var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheduleDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C7.10938 0 7.625 0.515625 7.625 1.125V3H14.375V1.125C14.375 0.515625 14.8438 0 15.5 0C16.1094 0 16.625 0.515625 16.625 1.125V3H18.5C20.1406 3 21.5 4.35938 21.5 6V6.75V9V21C21.5 22.6875 20.1406 24 18.5 24H3.5C1.8125 24 0.5 22.6875 0.5 21V9V6.75V6C0.5 4.35938 1.8125 3 3.5 3H5.375V1.125C5.375 0.515625 5.84375 0 6.5 0ZM19.25 9H2.75V21C2.75 21.4219 3.07812 21.75 3.5 21.75H18.5C18.875 21.75 19.25 21.4219 19.25 21V9ZM9.875 19.125V14.3438L8.04688 16.1719C7.57812 16.6406 6.875 16.6406 6.45312 16.1719C5.98438 15.75 5.98438 15.0469 6.45312 14.5781L10.2031 10.8281C10.625 10.4062 11.3281 10.4062 11.7969 10.8281L15.5469 14.5781C15.9688 15.0469 15.9688 15.75 15.5469 16.1719C15.0781 16.6406 14.375 16.6406 13.9531 16.1719L12.125 14.3438V19.125C12.125 19.7812 11.6094 20.25 11 20.25C10.3438 20.25 9.875 19.7812 9.875 19.125Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheduleDate);
export default __webpack_public_path__ + "static/media/sheduleDate.8d3b87d5b29714a20f6a28f630445524.svg";
export { ForwardRef as ReactComponent };